import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface FinData {
  name: string;
  fin: string;
}

@Component({
    selector: 'app-fin-dialog',
    templateUrl: './fin-dialog.component.html',
    styleUrls: ['./fin-dialog.component.css'],
    standalone: false
})
export class FinDialogComponent {

  showConfirmationPage = false;

  constructor(
    public dialogRef: MatDialogRef<FinDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FinData
  ) { }

  onCancel(): void {
    this.dialogRef.close();
  }

  onAdd(): void {
    this.showConfirmationPage = true;
  }

  onSave(): void {
    // the FIN input is type="number", so ngModel hands back a number — normalize it to a
    // string here so callers never have to compare a number against a stored string FIN
    this.dialogRef.close({
      name: String(this.data.name ?? '').trim(),
      fin: String(this.data.fin ?? '').trim()
    } as FinData);
  }
}
